import * as React from "react";
import { REFINED, BRAND } from "../../components/risikoanalyseStep/tokens";
import type { ProfileTabsProps } from "./profileShell";

/**
 * Sticky, horizontal scrollbare Tab-Leiste der Profil-Seite. Aktiver Tab mit
 * Gold-Underline. Alle vier Tabs sind sichtbar (auch disabled-Sektionen,
 * Vorplan §2/M4); disabled-Tabs sind dezent ausgegraut, bleiben aber klickbar
 * (Scroll-To zum Platzhalter).
 *
 * Touch-Targets ≥ 44px (Mobile). `position: sticky; top: 0` relativ zum
 * scrollenden Content-Bereich; z-index unter dem globalen Nav-Header.
 */
export const ProfileTabs: React.FC<ProfileTabsProps> = ({ items, activeSection, onSelect }) => {
  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 5,
        backgroundColor: REFINED.white,
        borderBottom: `1px solid ${REFINED.line}`,
        display: "flex",
        gap: 4,
        overflowX: "auto",
        whiteSpace: "nowrap",
        marginBottom: 20,
        // dezente Scrollbar auf Mobile
        WebkitOverflowScrolling: "touch",
      }}
      aria-label="Profil-Abschnitte"
    >
      {items.map((item) => {
        const active = item.id === activeSection;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onSelect(item.id)}
            aria-current={active ? "true" : undefined}
            style={{
              appearance: "none",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              minHeight: 44,
              padding: "0 16px",
              fontFamily: REFINED.fontUI,
              fontSize: "0.92rem",
              fontWeight: active ? 700 : 600,
              color: active ? REFINED.ink : item.enabled ? REFINED.ink2 : REFINED.ink3,
              borderBottom: active ? `2px solid ${BRAND.gold}` : "2px solid transparent",
              transition: "color 140ms ease, border-color 140ms ease",
              flexShrink: 0,
            }}
          >
            {item.label}
          </button>
        );
      })}
    </nav>
  );
};

export default ProfileTabs;
